export default {
    extensions: "Format",
    project_name: "Elanco School",
    welcome_to: "Bienvenue chez"
}